<script setup lang="ts">
/** 이름 목록 편집(회원 / 퇴임 이사 / 지정 서명자) — 모델 배열을 직접 고친다. ✨ 로 인물 조회. */
const props = withDefaults(defineProps<{
  rows: Array<{ name: string; [k: string]: any }>;
  addLabel?: string;
  placeholder?: string;
  emptyNote?: string;
  minRows?: number;
}>(), { addLabel: '+ Add', placeholder: 'Name', emptyNote: '', minRows: 0 });

const emit = defineEmits<{ (e: 'lookup', index: number): void }>();

function add() { props.rows.push({ name: '' }); }
function remove(i: number) { if (props.rows.length > props.minRows) props.rows.splice(i, 1); }
</script>

<template>
  <div class="re">
    <div v-if="!rows.length && emptyNote" class="re-empty">{{ emptyNote }}</div>
    <div v-for="(r, i) in rows" :key="i" class="re-row">
      <span class="re-no">{{ i + 1 }}.</span>
      <input v-model="r.name" class="re-in" :placeholder="placeholder" />
      <button type="button" class="re-ic" title="Look up from chat" @click="emit('lookup', i)">✨</button>
      <button type="button" class="re-rm" title="Remove" :disabled="rows.length <= minRows" @click="remove(i)">×</button>
    </div>
    <button type="button" class="re-add" @click="add">{{ addLabel }}</button>
  </div>
</template>

<style scoped>
.re { margin: 4px 0 8px 18px; }
.re-row { display: flex; align-items: center; gap: 4px; margin: 2px 0; }
.re-no { min-width: 18px; font-weight: 700; }
.re-in { flex: 1; min-width: 0; border: none; border-bottom: 1px dashed #b9c2d0; background: #f7f9fc; font: inherit; font-weight: 600; padding: 2px 4px; outline: none; }
.re-in:focus { border-bottom-color: #1b84ff; background: #eef5ff; }
.re-ic { border: none; background: transparent; cursor: pointer; font-size: 13px; padding: 0 2px; }
.re-rm { border: none; background: transparent; color: #c0392b; cursor: pointer; font-size: 15px; }
.re-rm:disabled { color: #cbd2dc; cursor: default; }
.re-add { border: 1px solid #1b84ff; background: #fff; color: #1b84ff; border-radius: 999px; padding: 2px 10px; font-size: 11px; font-weight: 700; cursor: pointer; margin-top: 4px; }
.re-empty { font-size: 11px; color: #9aa6bd; font-style: italic; }
</style>
